import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/icon-v2.0.0'
import v210 from '@nodes/icon-v2.1.0'

export default reactNode(
	'Icon',
	{
		'v2.0.0': v200,
		'v2.1.0': v210,
	},
	{ docs: '' }
)
